import { normalizeUiMessage } from '../../utils/message-normalizer';
import { Component, OnInit } from '@angular/core';
import { ModalController, PopoverController, NavParams, LoadingController, ToastController } from '@ionic/angular';
import moment from 'moment';
import 'moment-timezone';
import { DatePipe } from '@angular/common';
import { OrderSlotService } from 'src/app/services/order-slot.service';

@Component({
  selector: 'app-edit-time-slot-selection',
  templateUrl: './edit-time-slot-selection.component.html',
  styleUrls: ['./edit-time-slot-selection.component.scss'],
})
export class EditTimeSlotSelectionComponent implements OnInit {
  selectedTime: string;
  timeSlots: string[] = [];
  todaysDate: string;
  selectedDate: string;
  loading: any;
  slotArray: any[] = [];

  constructor(private modalController: ModalController,private popoverController: PopoverController, private navParams: NavParams, public loadingController: LoadingController, public toastController: ToastController, public datePipe: DatePipe, public orderSlot: OrderSlotService) { }

  ngOnInit() {
    this.selectedDate = this.navParams.get('selectedDate');
    this.todaysDate = this.getLocationSpecificGMTFormate("YYYY-MM-DD");
    console.log(this.todaysDate)    
    this.getSlotsForDate();
  }

  getLocationSpecificGMTFormate(format: string): string {
    const timezone = JSON.parse(localStorage.getItem('timezone')).timezoneName;
    return moment.tz(timezone).format(format);
  }

  getSlotsForDate() {
    if(this.selectedDate == this.todaysDate) {
      var time = this.getLocationSpecificGMTFormate('HH:mm:ss');
    }
    else {
      var time = '00:00:00';
    }

    this.getShiftSlotsByOrderSourceId(this.datePipe.transform(this.selectedDate, "yyy-MM-dd"),
      time);
  }

  async getShiftSlotsByOrderSourceId(date, time,) {

    // let business = JSON.parse(localStorage.getItem("allBusinesses"));
    // business[0].businessHours;
    let businessHours = JSON.parse(localStorage.getItem("businessHours"));
    let dayofWeek = parseInt(moment(date).format('e')) + 1;
    console.log('dayofWeek===', dayofWeek);

    let businesClose = true;
    let businessHourList = [];
    if (businessHours) {
      for (let index = 0; index < businessHours.length; index++) {
        const element = businessHours[index];
        if (dayofWeek == element.day.id) {
          if (element.isClosed == 0) {

            businesClose = false;
            businessHourList.push(element);

          }

        }

      }
    }


    if (!businesClose) {
      await this.presentLoading('Loading slot...');

      let orderSource: any = JSON.parse(localStorage.getItem("selectedOrderSourceGroupObject"));
      await this.orderSlot.getShiftSlotsByOrderSourceId(orderSource.orderSouceDisplayPackets.id, date, time)
        .subscribe(async (data: any) => {
          let res = []
          let responseSlot = data;
          for (let slot of responseSlot) {
            for (let hour of businessHourList) {
              let format = 'HH:mm:ss'
              // var time = moment() gives you current time. no format required.

              let timeCheck = moment(slot.slotTime, format);

              let beforeTime = moment(hour.timeFrom, format);
              let afterTime = moment(hour.timeTo, format);
              if (timeCheck.isBetween(beforeTime, afterTime)) {
                res.push(slot)
              }
            }
          }

          if (this.selectedDate == undefined)
            this.selectedDate = this.getLocationSpecificGMTFormate('dddd, DD MMM YYYY');
          this.slotArray = [];

          for (let index = 0; index < res.length; index++) {
            const element = res[index];

            let date1: any = new Date().setHours((element.slotTime.split(':'))[0], (element.slotTime.split(':'))[1], (element.slotTime.split(':'))[2]);
            let date2: any = new Date(date1 + 1000 * 60 * element.slotInterval);
            element.slotTimeDisplay = this.datePipe.transform(date1, "hh:mm a");
            element.slotEndTimeDisplay = this.datePipe.transform(date2, "hh:mm a");

          }

          for (let index = 0; index < res.length; index++, index++) {
            const element1 = res[index];
            const element2 = res[index + 1];

            let tempArray = [];
            element1.isSelected = false;
            tempArray.push(element1);
            if (element2) {
              element2.isSelected = false;
              tempArray.push(element2);
            } else {

              tempArray.push({});
            }


            this.slotArray.push(tempArray);
          }

          // this.slotArray = res;
          await this.loading.dismiss();

        }, err => {
          console.log(err);
          this.presentToast(err);
          this.loading.dismiss();

        });
    }
  }

  apply() {
    console.log('Selected time:', this.selectedTime);
    // Handle time application logic here
    this.dismissModal();
  }

  dismissModal() {
    this.popoverController.dismiss(this.selectedTime);
  }

  async presentLoading(msg) {
    this.loading = await this.loadingController.create({
      message: msg
    });
    // Present the loading controller
    await this.loading.present();
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: normalizeUiMessage(msg),
      duration: 2000,
      position: 'middle',
      cssClass: "toast-mess"
    });
    toast.present();
  }

}
